var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLougout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.9492L21 12.9492M21 12.9492L16 7.94922M21 12.9492H9M12 17.9492C12 18.8792 12 19.3442 11.8978 19.7257C11.6204 20.761 10.8117 21.5696 9.77646 21.847C9.39496 21.9492 8.92997 21.9492 8 21.9492H7.5C6.10218 21.9492 5.40326 21.9492 4.85195 21.7209C4.11687 21.4164 3.53284 20.8324 3.22836 20.0973C3 19.546 3 18.847 3 17.4492V8.44922C3 7.05139 3 6.35248 3.22836 5.80117C3.53284 5.06608 4.11687 4.48206 4.85195 4.17758C5.40326 3.94922 6.10218 3.94922 7.5 3.94922H8C8.92997 3.94922 9.39496 3.94922 9.77646 4.05144C10.8117 4.32884 11.6204 5.13749 11.8978 6.17276C12 6.55426 12 7.01925 12 7.94922",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLougout);
export default __webpack_public_path__ + "static/media/lougout.1c16ee74152929cc7fa825c46f39edc0.svg";
export { ForwardRef as ReactComponent };